@if (isLoading()) {
    <app-loading />
} @else {
    <div class="p-2">
        <h1 class="capitalize">{{ projectName }}</h1>
        <h2>Standard {{ standardName }}</h2>

        <p>{{ today | translocoDate }}</p>
    </div>
    <app-statistics-panel
        [isPrintScreen]="true"
        (ready)="printPage()" />
}
